import React from "react";
import { Helmet } from "react-helmet-async";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import WhiteNavbar from "components/Navbars/WhiteNavbar";
import Footer from "components/Footers/Footer";
import { ACIK_RIZA_TEXT } from "content/legal/AcikRizaMetniText";

const AcikRiza = () => {
  React.useEffect(() => {
    document.body.classList.add("contact-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    return function cleanup() {
      document.body.classList.remove("contact-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  const formattedAcikRizaText = (ACIK_RIZA_TEXT || "")
    .trim()
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replace(
      /Ekşioğlu Hukuk Danışmanlık Ofisi/g,
      "<strong>Ekşioğlu Hukuk Danışmanlık Ofisi</strong>",
    )
    .replace(
      /Kişisel verilerin işlenmesi hakkında aydınlatma metni kapsamında/g,
      "<strong>Kişisel verilerin işlenmesi hakkında aydınlatma metni kapsamında</strong>",
    );

  return (
    <>
      <Helmet>
        <title>Açık Rıza Metni | Ekşioğlu Hukuk</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Kişisel verilerin işlenmesine ilişkin açık rıza metni."
          data-rh="true"
        />
        <link
          rel="canonical"
          href="https://www.eksiogluhukukofisi.com/acik-riza-metni"
        />
        <meta property="og:title" content="Açık Rıza Metni | Ekşioğlu Hukuk" />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="Kişisel verilerin işlenmesine ilişkin açık rıza metni."
        />
        <meta
          property="og:image"
          content="https://www.eksiogluhukukofisi.com/static/media/eksiogluWhiteLogo.e14b5e9c41e5271d670c.png"
        />
        <meta
          property="og:url"
          content="https://www.eksiogluhukukofisi.com/acik-riza-metni"
        />
      </Helmet>

      <div>
        <WhiteNavbar />

        <Container>
          <div className="section">
            <Row>
              <Col className="ml-auto mr-auto text-center" md="12">
                <div className="my-6">
                  <h1
                    className="font-weight-bold font-sans"
                    style={{
                      background: "linear-gradient(135deg, #0F172A, #333333)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontSize: "2.2em",
                      marginBottom: "18px",
                    }}
                  >
                    AÇIK RIZA METNİ
                  </h1>
                </div>
              </Col>
            </Row>

            <Row>
              <Col className="ml-auto mr-auto" md="12">
                <Card className="bg-white rounded-lg shadow-lg overflow-hidden font-sans">
                  <CardBody className="p-4">
                    <div
                      style={{
                        whiteSpace: "pre-wrap",
                        lineHeight: 1.75,
                        color: "#0F172A",
                        fontSize: 14,
                      }}
                      dangerouslySetInnerHTML={{
                        __html: formattedAcikRizaText,
                      }}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default AcikRiza;
